import React from 'react';
import { Link, useLocation } from 'react-router-dom';
// Import your icons
import dashboardIcon from '@assets/navbar/dashboard-icon.svg';
import walletIcon from '@assets/navbar/wallet-icon.svg';
import barsIcon from '@assets/navbar/bars-icon.svg';
import fileIcon from '@assets/navbar/file-icon.svg';
import reportsIcon from '@assets/navbar/reports-icon.svg';
import settingsIcon from '@assets/navbar/settings-icon.svg';
import {
  CONTACT_US_URL,
  COOKIE_POLICY_URL,
  DISCLOSURES_URL,
  PRIVACY_POLICY_URL,
  TERMS_AND_CONDITIONS_URL,
} from '@/constants/legalLinks';
import styles from './Navbar.module.css'; /* ✅ Import CSS module */

// Footer disclosure links (#155) — targets live in @/constants/legalLinks.
const footerLinks = [
  { label: 'Disclosures', href: DISCLOSURES_URL },
  { label: 'Privacy Policy', href: PRIVACY_POLICY_URL },
  { label: 'Terms & Conditions', href: TERMS_AND_CONDITIONS_URL },
  { label: 'Cookie Policy', href: COOKIE_POLICY_URL },
  { label: 'Contact us', href: CONTACT_US_URL },
];

const Navbar: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: dashboardIcon },
    { path: '/purchase', label: 'Purchase assets', icon: barsIcon },
    { path: '/manage', label: 'Manage assets', icon: fileIcon },
    { path: '/wallet', label: 'Wallet', icon: walletIcon },
    { path: '/reports', label: 'Reports', icon: reportsIcon },
  ];

  const _settingItems = [{ path: '/settings', label: 'Settings', icon: settingsIcon }];

  return (
    <nav className={styles.navbar}>
      <ul>
        {menuItems.map((item) => {
          let isActive;
          if (item.path === '/wallet') {
            isActive = location.pathname === item.path || location.pathname.startsWith('/wallet/');
          } else if (item.path === '/manage') {
            isActive = location.pathname === item.path || location.pathname.startsWith('/manage/');
          } else {
            isActive = location.pathname === item.path;
          }

          return (
            <li
              key={item.path}
              className={`${styles.navbarItem} ${isActive ? styles.navbarItemActive : ''}`}
            >
              <Link
                to={item.path}
                className={`${styles.navbarLink} ${isActive ? styles.navbarLinkActive : ''}`}
              >
                <div className={styles.navbarIconContainer}>
                  <img src={item.icon} alt={`${item.label} icon`} />
                </div>
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>

      {/* Footer Links */}
      <div className={styles.footerLinks}>
        {footerLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className={styles.footerLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
